import React from 'react'

const Myinput = ({name, Key, Type, Id, childToParent}) => {
    const handlearrow = event =>{
        if(event.target.type == 'checkbox'){
            var eve = event.target.parentElement.parentElement.querySelectorAll('input');
            var tr = 0;
            for(var r=0; r< eve.length; r++){
                if(eve[r].checked){
                    tr=tr+1;
                    eve[r].parentElement.style.color = '#F62369'
                }
                else {
                    eve[r].parentElement.style.color = '#000';
                }
            }
            if(tr>0){
                document.getElementById("plus").classList.remove("quizdisablePlus");
            }
            else{
                document.getElementById("plus").classList.add("quizdisablePlus");
            }
        }
        else if(event.target.type == 'radio'){
            eve = event.target.parentElement.parentElement.querySelectorAll('input');
            for(var rr=0; rr< eve.length; rr++){
                if(eve[rr].checked){
                    // event.target.parentElement.style.Animation = 'blink 0.5s linear infinite';
                    event.target.parentElement.style.color = '#F62369'
                }
                else {
                    eve[rr].parentElement.style.color = '#000';
                }
            }
            document.getElementById("plus").classList.remove("quizdisablePlus");
        }
    }
    return (
        Type=="radio" ? (
            <input name={name} onChange={() => childToParent()} type={Type} key={Key} id={Id} onClick={handlearrow}></input>
          ) : (
            <input name={name} type={Type} key={Key} id={Id} onClick={handlearrow}></input>
          )
    );
}

export default Myinput;